/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    BooleanField,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    NumberField,
    Datagrid,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { BooleanInput, NumberInput, TextInput } from '../lib/wrappers/Inputs';
export const DurationLabels = { pageTitle: 'Durations' };

export const DurationList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={DurationLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField label="Description" source="Title" />
                    <TextField source="duration" />
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const DurationEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput label="Description" source="Title" />
                    <NumberInput source="duration" />
                    <BooleanInput source="current" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const DurationCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput label="Description" source="Title" />
            <BooleanInput source="current" />
            <NumberInput source="duration" />
        </SimpleForm>
    </Create>
);

export const DurationShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label="Description" source="Title" />
            <NumberField source="duration" />
            <BooleanField source="current" />
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
